import React, { useState } from "react";
import styled from "styled-components";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";

export default function Select({ value = "", options = [], onChange }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  function handleSetIsOpen(io) {
    setIsOpen(io);
  }

  function getTitleSelect(val, list) {
    if (!val) return "Select";
    return list.find((i) => i.value === val).title;
  }

  function handleChangeValue(val) {
    if (val === value) return;
    onChange(val);
    handleSetIsOpen(false);
  }

  return (
    <OutsideClickHandler onOutsideClick={() => handleSetIsOpen(false)}>
      <StyledSelect>
        <div
          className="select__display"
          onClick={() => handleSetIsOpen(!isOpen)}
        >
          <p>{t(getTitleSelect(value, options))}</p>
          <i className="icon icon-arrow-down-s"></i>
        </div>
        {isOpen && (
          <ul className="select__list">
            {options.map((i) => (
              <li key={i.id} onClick={() => handleChangeValue(i.value)}>
                {t(i.title)}
              </li>
            ))}
          </ul>
        )}
      </StyledSelect>
    </OutsideClickHandler>
  );
}

const StyledSelect = styled.div`
  position: relative;

  .select {
    &__display {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 6px 10px 6px 14px;
      border-radius: 4px;
      background-color: var(--white);
      color: var(--black);
      box-shadow: 0 15px 30px -10px transparentize(#000, 0.9);
      gap: 12px;
      cursor: pointer;

      p {
        color: var(--title);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 146.667% */
      }

      i {
        background-color: var(--black);
        width: 18px;
        height: 18px;
      }
    }

    &__list {
      position: absolute;
      overflow: hidden;
      background-color: var(--white);
      color: var(--black);
      list-style: none;
      padding: 0;
      margin: 0;
      min-width: 100%;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 105%);
      border-radius: 4px;
      z-index: 4;
      box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

      li {
        padding: 6px 8px 6px 12px;
        cursor: pointer;
        color: var(--text);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 146.667% */

        &:hover {
          background-color: var(--light-blue);
          color: var(--white);
        }
      }
    }
  }
`;
